import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import PlaceholderWrapper from "../Common/PlaceholderWrapper";
import i18next from "i18next";
import GridView from "@mnjsplatform/components/lib/common/GridView/GridView";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";
import paramRender from "@mnjsplatform/components/lib/common/ParamRenderUniversal";
import ActionLink from "../../../../MnJsPlatform.UI.Components/lib/common/ActionLink";
import confirm from "@mnjsplatform/components/lib/common/ConfirmFn";
import {withRouter} from "react-router";
import $ from "jquery";
import CreateRef from "./CreateRef";
import EditRef from "./EditRef";
import AuthProvider from "@mnjsplatform/data/lib/security/authProvider";
import pathJoin from "@mnjsplatform/data/lib/utils/pathJoin";

class References1 extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            showCreateRef: false,
            showEditRef: false,
            currentRow: null,
            readOnly: false
        }
    }

    async componentDidMount() {
        await this.props.dispatch(this.props.dataItem_List.execute());
    }

    loadDocuments = async (row) => {
        const documentKey = this.props.dataItem_List.getRowKey(row);
        await this.props.dispatch(this.props.dataItem_LoadList.execute(documentKey));
        console.log(`rowsCount: ${this.props.dataItem_LoadList.rowsCount()}`);
        const delay = () => new Promise(resolve => setTimeout(resolve, 1000));

        if (!this.props.dataItem_LoadList.isError && this.props.dataItem_LoadList.rowsCount() > 0) {
            const token = await AuthProvider.getToken();
            for (const rowFile of this.props.dataItem_LoadList.rawData.DataTable) {
                const fileKey = this.props.dataItem_LoadList.getRowKey(rowFile);
                const key = Object.assign({}, {b_token: token}, fileKey);
                const link = document.createElement("a");
                link.href = pathJoin(window.config.apiRoot, "References", "LoadDocument") + "?" + $.param(key);
                console.log(`url: ${link.href}`);
                link.click();
                await delay();
            }
        }
    }

    createNewRef = () => {
        this.setState({showCreateRef: true})
    };

    hideNewRef = async () => {
        this.setState({showCreateRef: false});
        await this.refresh();
    };

    refCreated = async (row) => {
        this.editRef(row, false);
    }

    showEditRef = () => {
        this.setState({showEditRef: true})
    };

    hideEditRef = (refresh = false) => {
        this.setState({showEditRef: false}, (refresh ? this.refresh : null))
    }

    deleteRef = async (row) => {
        try {
            await confirm(i18next.t("References_1"));
            await this.props.dispatch(this.props.dataItem_Delete.execute({EDocInfoOutIntId: row.EDocInfoOutIntId}));
            if (!this.props.dataItem_Delete.isError)
                await this.props.dispatch(this.props.dataItem_List.execute());
        } catch {
        }
    }

    reqRef = async (row) => {
        try {
            const text = row.TextAskDo || i18next.t("Edit_Ref_1");
            await confirm(text);

            await this.props.dispatch(this.props.dataItem_Request.execute({EDocInfoOutIntId: row.EDocInfoOutIntId}));
            if (!this.props.dataItem_Request.isError)
                await this.refresh();
        } catch {
        }
    }

    viewRef = async (row) => {
        const token = await AuthProvider.getToken();
        const downloadPath = pathJoin(window.config.apiRoot, "EDDocList", "DownloadDocument") + "?" + $.param({
            b_token: token,
            id: row.EDocIntId
        });
        window.open(downloadPath, '_blank');
    }

    editRef = (row, readOnly) => {
        this.setState({
            showEditRef: true,
            currentRow: row,
            readOnly: readOnly
        });
    }

    refresh = async () => {
        await this.props.dispatch(this.props.dataItem_List.execute());
    }

    render() {
        return (<>
            <PlaceholderWrapper placeholderId="10"
                                title={<><i className='fa fa-chain-broken'/>{i18next.t("References")}</>}
                                showSplitterLine={false} canCollapse={false}>

                {this.state.showCreateRef && <CreateRef onClose={this.hideNewRef} onCreated={this.refCreated}/>}
                {this.state.showEditRef && <EditRef onClose={this.hideEditRef} row={this.state.currentRow}
                                                    readOnly={this.state.readOnly}
                />}

                <div className="col-md-7">
                    {
                        <ComplexParam dataItem={this.props.dataItem_List_Params} dispatch={this.props.dispatch}
                                      renderParams={paramRender}
                                      autoApplyParams={true}
                                      rootPath="/"
                                      parentDataItem={this.props.dataItem_List}
                        />}
                </div>

                <span>&nbsp;</span>
                <GridView dataItem={this.props.dataItem_List} dispatch={this.props.dispatch} readOnly={false}
                          renderCellEx={this.renderCellEx}/>
                <button type="button" className="btn btn-regular -goahead"
                        title={i18next.t("References_2")} onClick={this.createNewRef}>
                    {i18next.t("References_2")}
                </button>
            </PlaceholderWrapper>
        </>)
    }

    renderCellEx = (cellParams) => {
        const {
            key,
            row,
            rowIndex,
            fieldInfo,
            fieldIndex,
            renderCellDefault
        } = cellParams;

        let self = this;

        if (fieldInfo.Name === "TextDel" && row["EnableDel"] === 1) {
            return <ActionLink onSelect={async () =>
                await this.deleteRef(row)
            }>{row["TextDel"]}</ActionLink>
        }

        if (fieldInfo.Name === "TextReq" && row["EnableReq"] === 1) {
            return <ActionLink onSelect={async () =>
                await this.reqRef(row)
            }>{row["TextReq"]}</ActionLink>
        }

        if (fieldInfo.Name === "TextView" && row["EnableView"] === 1) {
            return <ActionLink onSelect={() =>
                this.viewRef(row)
            }>{row["TextView"]}</ActionLink>
        }

        if (fieldInfo.Name === "TextOut" && row["EnableOut"] === 1) {
            return <ActionLink onSelect={async () =>
                await this.loadDocuments(row)
            }>{row["TextOut"]}</ActionLink>
        }

        if (fieldInfo.Name === "TextPar") {
            return <ActionLink onSelect={() =>
                this.editRef(row, row.StatusInfoOut !== 1)
            }>{row["TextPar"]}</ActionLink>
        }
        return renderCellDefault(row, fieldInfo, fieldIndex);
    }
}

References1.propTypes = {
    dispatch: PropTypes.func.isRequired
};

References1.defaultProps = {};

function mapStateToProps(state, ownProps) {
    return {
        dataItem_List: state.referencesState.EDocInfoOut_ListForPO,
        dataItem_List_Params: state.referencesState.EDocInfoOut_ListForPO_Params,
        dataItem_Delete: state.referencesState.EDocInfoOut_ListForPO_Del,
        dataItem_Request: state.referencesState.EDocInfoOut_RequestPO,
        dataItem_LoadList: state.referencesState.EDocInfoOut_GetForLoadListPO,
        dataItem_LoadFile: state.referencesState.EDocInfoOut_GetForLoadFilePO
    }
}

export default withRouter(connect(mapStateToProps)(References1));